import { render, staticRenderFns } from "./empty-layout.vue?vue&type=template&id=898d781a"
import script from "./empty-layout.vue?vue&type=script&lang=js"
export * from "./empty-layout.vue?vue&type=script&lang=js"
import style0 from "./empty-layout.vue?vue&type=style&index=0&id=898d781a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports